const sortOrders = [
  { name: 'Default', slug: 'default' },
  { name: 'Management Fee', order: ' (Lowest)', slug: 'management-fee-lowest' },
  { name: 'Growth Since Inception', order: ' (Highest)', slug: 'growth-since-inception-highest' },
  { name: 'Performance 1 Month', order: ' (Highest)', slug: '1-month-performance-highest' },
  { name: 'Performance 1 Year', order: ' (Highest)', slug: '1-year-performance-highest' },
  { name: 'Performance 3 Years', order: ' (Highest)', slug: '3-years-performance-highest' },
  { name: 'Performance 5 Years', order: ' (Highest)', slug: '5-years-performance-highest' },
];

export default sortOrders;
